import React, { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';

import { ClickAwayListener, createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';

import { Typography } from './Typography';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing.unit * 2,
    },
    colorPicker: {
      display: 'flex',
    },
    colorSquare: {
      width: 42,
      height: 42,
      cursor: 'pointer',
      border: `1px solid ${theme.custom.palette.colorLightBlue}`,
      borderRight: 'none',
    },
    colorInput: {
      width: 94,
      border: `1px solid ${theme.custom.palette.colorLightBlue}`,
      paddingLeft: theme.spacing.unit,
      outline: 'none',
      fontSize: theme.custom.fontSizes.small,
      color: theme.palette.text.primary,
    },
    widthFit: {
      width: 'fit-content',
      position: 'absolute',
      zIndex: 30,
    },
  });

export interface ColorPickerProps extends WithStyles<typeof styles> {
  value: string;
  label?: string;
  onChange: (color: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ classes, value, label, onChange }) => {
  const [tmpColor, setTmpColor] = useState(value);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTmpColor(value);
  }, [value]);

  return (
    <div>
      {label && (
        <Typography className={classes.root} variant="subtitle1" color="supportSteel">
          {label}
        </Typography>
      )}
      <div className={classes.colorPicker}>
        <div onClick={() => setOpen(true)} className={classes.colorSquare} style={{ backgroundColor: tmpColor }} />
        <input
          className={classes.colorInput}
          maxLength={7}
          value={tmpColor}
          onChange={(e) => setTmpColor(e.target.value)}
          onBlur={() => onChange(tmpColor)}
        />
      </div>
      {open && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <div className={classes.widthFit}>
            <SketchPicker
              color={tmpColor}
              onChange={(colorState) => setTmpColor(colorState.hex)}
              onChangeComplete={(colorState) => onChange(colorState.hex)}
            />
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default withStyles(styles)(ColorPicker);
